var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___WXRTU1",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___WXRTU1",
  "Se": "ChannelAttachmentArea.module__upload___WXRTU1",
  "PO": "ChannelAttachmentArea.module__uploadContainer___WXRTU1",
  "il": "ChannelAttachmentArea.module__mediaContainer___WXRTU1",
  "BA": "ChannelAttachmentArea.module__clickableMedia___WXRTU1",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___WXRTU1",
  "R": "ChannelAttachmentArea.module__hidden___WXRTU1",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___WXRTU1",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___WXRTU1",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___WXRTU1",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___WXRTU1",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___WXRTU1",
  "p6": "ChannelAttachmentArea.module__spoiler___WXRTU1",
  "$_": "ChannelAttachmentArea.module__media___WXRTU1",
  "_A": "ChannelAttachmentArea.module__tags___WXRTU1",
  "H6": "ChannelAttachmentArea.module__filenameContainer___WXRTU1",
  "iW": "ChannelAttachmentArea.module__filename___WXRTU1",
  "VF": "ChannelAttachmentArea.module__fileDetails___WXRTU1",
  "Ov": "ChannelAttachmentArea.module__fileSize___WXRTU1",
  "i_": "ChannelAttachmentArea.module__fileExtension___WXRTU1",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___WXRTU1",
  "KY": "ChannelAttachmentArea.module__actionBar___WXRTU1" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___WXRTU1" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___WXRTU1",
  "le": "ChannelAttachmentArea.module__actionBarIcon___WXRTU1",
  "s3": "ChannelAttachmentArea.module__altTag___WXRTU1",
  "Kk": "ChannelAttachmentArea.module__icon___WXRTU1",
  "Dp": "ChannelAttachmentArea.module__iconImage___WXRTU1",
  "vt": "ChannelAttachmentArea.module__videoModal___WXRTU1",
  "j": "ChannelAttachmentArea.module__videoContainer___WXRTU1",
  "yF": "ChannelAttachmentArea.module__divider___WXRTU1",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___WXRTU1",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___WXRTU1",
};

module.exports = exports;
